// extracted by mini-css-extract-plugin
export default {"burger":"OffcanvasMenu_burger__LPdkP","menu":"OffcanvasMenu_menu__YBxZC"};